import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Link, useLocation } from "react-router-dom";
import { AccountLandingPageContent, AccountLandingPageLayout } from "@ugg/shared/components/auth/AccountLandingPageLayout";
import { LoginForm } from "@ugg/shared/components/auth/LoginForm";
import { LoginFormFooter } from "@ugg/shared/components/auth/LoginFormFooter";
import { TermsDisclaimer } from "@ugg/shared/components/auth/TermsDisclaimer";
import { useEmailLogin } from "@ugg/shared/hooks/use-email-login";
import { parseQueryString } from "@ugg/shared/utils/url-query-params";
import { getSameOriginPath } from "@ugg/shared/utils/safe-redirect";
import { AppRoutes } from "@ugg/shared/routes/app-routes";
import { useCreateSupabaseAccountMutation } from "@ugitgud/legos/queries/auth";
import { useSiteOAuth } from "lib/hooks/use-site-oauth";

const Login = () => {
  const location = useLocation();
  const parsedQueryString = parseQueryString(location.search.substring(1));
  const isFromCheckout = parsedQueryString.continue?.startsWith(AppRoutes.CHECKOUT);

  useEffect(() => {
    window?.scrollTo(0, 0);
  }, []);

  const continueTo = getSameOriginPath(parsedQueryString.redirect_url || parsedQueryString.continue, AppRoutes.HOME);
  const oauth = useSiteOAuth(continueTo);
  const [createSupabaseAccount] = useCreateSupabaseAccountMutation();

  const onSignedIn = async () => {
    await createSupabaseAccount().catch(console.error);
    window.location.href = continueTo;
  };
  const emailLogin = useEmailLogin(onSignedIn);

  return (
    <AccountLandingPageLayout game={parsedQueryString.game}>
      <Helmet>
        <title>U.GG - Login</title>
      </Helmet>
      <AccountLandingPageContent
        backLink={
          <Link to={isFromCheckout ? AppRoutes.PLUS : AppRoutes.HOME}>
            &lt; {isFromCheckout ? "Back to PLUS" : "Back to Home"}
          </Link>
        }
      >
        <LoginForm {...emailLogin}>
          <LoginFormFooter
            signUpTo={AppRoutes.SIGNUP + location.search}
            recoverTo={AppRoutes.RECOVER_ACCOUNT}
            onOAuth={oauth.authenticate}
            oauthDisabled={oauth.isPending}
            oauthError={oauth.error}
          />
        </LoginForm>
        <TermsDisclaimer termsUrl={AppRoutes.TOS} privacyUrl={AppRoutes.PRIVACY_POLICY} />
      </AccountLandingPageContent>
    </AccountLandingPageLayout>
  );
};

export default Login;
